import { ref, computed } from 'vue';
import type { MediaItem } from '@/modules/media-library/components/media-library.interface';
import {
   fetchMediaLibrary,
   uploadMediaItem,
   deleteMediaItem,
   updateMediaItem,
} from '@/core/collections/media-library/media-library.service';

export function useMediaLibrary(id: number) {
   const mediaItems = ref<MediaItem[]>([]);
   const isFinished = ref(false);
   const searchValue = ref('');
   const selectedMedia = ref<MediaItem | null>(null);

   const displayedMedia = computed(() => {
      const normalizedSearchValue = searchValue.value.toLowerCase();

      const filteredMediaItems = mediaItems.value.filter((mediaItem) => {
         const normalizedMediaName = mediaItem.name.toLowerCase();
         const matchesSearchQuery = normalizedMediaName.includes(normalizedSearchValue);
         return matchesSearchQuery;
      });

      return filteredMediaItems;
   });

   async function load() {
      mediaItems.value = await fetchMediaLibrary(id);
      isFinished.value = true;
   }

   async function upload(file: File) {
      if (!file) return;

      const newItem = await uploadMediaItem(id, file);
      mediaItems.value = [newItem, ...mediaItems.value];
   }

   async function remove(mediaId: number) {
      await deleteMediaItem(id, mediaId);
      mediaItems.value = mediaItems.value.filter((mi) => mi.id !== mediaId);
   }

   async function edit(mediaId: number, changes: Partial<MediaItem>) {
      const updatedItem = await updateMediaItem(id, mediaId, changes);
      mediaItems.value = mediaItems.value.map((mi) => (mi.id === mediaId ? updatedItem : mi));
   }

   load();

   return {
      displayedMedia,
      isFinished,
      searchValue,
      selectedMedia,
      upload,
      remove,
      edit,
   };
}
